export enum ReportTimePeriod {
  QUARTERLY = "quarterly",
  MONTHLY = "monthly",
  WEEKLY = "weekly",
  DAILY = "daily",
}
